/* BORN — Displays · v3 interactions: Origin hero, drag rail, table peek, FAQ. Fails open. */
(function () {
  'use strict';
  var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var hoverable = window.matchMedia('(hover: hover) and (pointer: fine)').matches;
  var each = function (l, f) { Array.prototype.forEach.call(l, f); };
  var bound = function (el) { if (el.dataset.bnV3) return true; el.dataset.bnV3 = '1'; return false; };

  /* ---------------- H · Origin hero ---------------- */
  function initOrigin() {
    each(document.querySelectorAll('.bn-origin'), function (hero) {
      if (bound(hero)) return;
      var thumbs = hero.querySelectorAll('.bn-origin__thumb');
      var caption = hero.querySelector('.bn-origin__caption');
      var leaveTimer;

      // load choreography: stagger thumbs from small
      each(thumbs, function (t, i) { t.style.setProperty('--d', (260 + i * 90) + 'ms'); });
      function loaded() { hero.classList.add('is-loaded'); }
      requestAnimationFrame(function () { requestAnimationFrame(loaded); });
      setTimeout(loaded, 400);
      document.addEventListener('visibilitychange', function () { if (document.visibilityState === 'visible') loaded(); });

      function activate(t) {
        clearTimeout(leaveTimer);
        each(thumbs, function (x) { x.classList.toggle('is-on', x === t); });
        hero.setAttribute('data-active', t.getAttribute('data-for'));
        hero.classList.add('is-active');
        if (caption) { var l = t.querySelector('.bn-origin__thumb-label'); caption.textContent = l ? l.textContent.trim() : ''; }
      }
      function deactivate() {
        leaveTimer = setTimeout(function () {
          hero.classList.remove('is-active');
          each(thumbs, function (x) { x.classList.remove('is-on'); });
          // keep data-active until the fade completes so the image shrinks away, then clear
          setTimeout(function () { if (!hero.classList.contains('is-active')) hero.removeAttribute('data-active'); }, 1300);
        }, 90);
      }
      each(thumbs, function (t) {
        t.addEventListener('pointerenter', function () { activate(t); });
        // v4: thumbs may sit in two side columns (display:contents parent), so each thumb
        // also releases on its own pointerleave; activate() cancels the pending release
        // when the pointer lands on another thumb.
        t.addEventListener('pointerleave', deactivate);
        t.addEventListener('focus', function () { activate(t); });
        t.addEventListener('blur', deactivate);
        // touch: first tap previews, second follows
        t.addEventListener('click', function (e) {
          if (!hoverable && !t.classList.contains('is-on')) { e.preventDefault(); activate(t); }
        });
      });
      var row = hero.querySelector('.bn-origin__thumbs');
      if (row) row.addEventListener('pointerleave', deactivate);
      hero.addEventListener('keydown', function (e) { if (e.key === 'Escape') deactivate(); });

      // ticker: duplicate for a seamless loop
      var track = hero.querySelector('.bn-origin__ticker-track');
      if (track && !track.dataset.cloned) {
        track.dataset.cloned = '1';
        var kids = Array.prototype.slice.call(track.children);
        var reps = 0;
        // v4: the ticker pill is up to 760px wide, so fill to at least 1600px before mirroring
        while (track.getBoundingClientRect().width < 1600 && reps < 6) { kids.forEach(function (k) { track.appendChild(k.cloneNode(true)); }); reps++; }
        // Mirror the whole set once so translate(-50%) loops seamlessly
        Array.prototype.slice.call(track.children).forEach(function (k) { var c = k.cloneNode(true); c.setAttribute('aria-hidden', 'true'); track.appendChild(c); });
      }
    });
  }

  /* ---------------- R · Drag rail with inertia + snap ---------------- */
  function initRail3() {
    each(document.querySelectorAll('.bn-rail3-wrap'), function (wrap) {
      if (bound(wrap)) return;
      var track = wrap.querySelector('.bn-rail3'); if (!track) return;
      var prev = wrap.querySelector('[data-bn-rail-prev]');
      var next = wrap.querySelector('[data-bn-rail-next]');
      var titleA = wrap.querySelector('[data-bn-rail-title-a]');
      var titleB = wrap.querySelector('[data-bn-rail-title-b]');
      var cards = track.querySelectorAll('.bn-rail3__card');

      function step() { var c = cards[0]; return c ? c.getBoundingClientRect().width + 20 : track.clientWidth * .8; }
      function sync() {
        var max = track.scrollWidth - track.clientWidth - 2;
        if (prev) prev.disabled = track.scrollLeft <= 2;
        if (next) next.disabled = track.scrollLeft >= max;
        if (titleA && cards.length) {
          var tl = track.getBoundingClientRect().left + parseFloat(getComputedStyle(track).paddingLeft || 0);
          var best = null, bd = Infinity;
          each(cards, function (c) { var d = Math.abs(c.getBoundingClientRect().left - tl); if (d < bd) { bd = d; best = c; } });
          if (best) {
            /* The dash between the halves is drawn by CSS (born-v12.css block 5c, gated
               on this section's "Em dash after the first line" setting) and is NOT written
               into the text here — otherwise turning that setting on renders two. */
            if (best.dataset.title && titleA.textContent !== best.dataset.title) titleA.textContent = best.dataset.title;
            if (titleB) titleB.textContent = best.dataset.sub || '';
          }
        }
      }
      if (prev) prev.addEventListener('click', function () { track.scrollBy({ left: -step(), behavior: reduced ? 'auto' : 'smooth' }); });
      if (next) next.addEventListener('click', function () { track.scrollBy({ left: step(), behavior: reduced ? 'auto' : 'smooth' }); });
      track.addEventListener('scroll', sync, { passive: true });
      window.addEventListener('resize', sync, { passive: true });

      // keyboard
      track.setAttribute('tabindex', '0');
      track.addEventListener('keydown', function (e) {
        if (e.key === 'ArrowRight') { e.preventDefault(); track.scrollBy({ left: step(), behavior: reduced ? 'auto' : 'smooth' }); }
        if (e.key === 'ArrowLeft') { e.preventDefault(); track.scrollBy({ left: -step(), behavior: reduced ? 'auto' : 'smooth' }); }
      });

      // pointer drag with inertia
      var down = false, moved = false, startX = 0, startLeft = 0, lastX = 0, lastT = 0, vel = 0, raf;
      function onDown(e) {
        // Touch already has native momentum + snap; only mouse/pen get the custom drag.
        if (e.pointerType === 'touch') return;
        if (e.pointerType === 'mouse' && e.button !== 0) return;
        down = true; moved = false; startX = e.clientX; startLeft = track.scrollLeft; lastX = e.clientX; lastT = performance.now(); vel = 0;
        cancelAnimationFrame(raf);
        wrap.classList.add('is-touched');
        track.setPointerCapture && track.setPointerCapture(e.pointerId);
      }
      function onMove(e) {
        if (!down) return;
        var dx = e.clientX - startX;
        if (!moved && Math.abs(dx) > 4) { moved = true; track.classList.add('is-dragging'); }
        if (!moved) return;
        track.scrollLeft = startLeft - dx;
        var now = performance.now(), dt = Math.max(1, now - lastT);
        vel = (e.clientX - lastX) / dt; lastX = e.clientX; lastT = now;
      }
      function snapToNearest() {
        var tl = track.getBoundingClientRect().left + parseFloat(getComputedStyle(track).paddingLeft || 0);
        var best = null, bd = Infinity;
        each(cards, function (c) { var d = c.getBoundingClientRect().left - tl; if (Math.abs(d) < Math.abs(bd)) { bd = d; best = c; } });
        if (best) track.scrollBy({ left: bd, behavior: reduced ? 'auto' : 'smooth' });
      }
      function onUp(e) {
        if (!down) return; down = false;
        if (!moved) { return; }
        var v = vel * 16; // px per frame
        function coast() {
          v *= .94;
          track.scrollLeft -= v;
          if (Math.abs(v) > .6) raf = requestAnimationFrame(coast);
          else { track.classList.remove('is-dragging'); snapToNearest(); }
        }
        if (reduced) { track.classList.remove('is-dragging'); snapToNearest(); }
        else raf = requestAnimationFrame(coast);
        // swallow the click that follows a drag
        var swallow = function (ev) { ev.preventDefault(); ev.stopPropagation(); track.removeEventListener('click', swallow, true); };
        track.addEventListener('click', swallow, true);
        setTimeout(function () { track.removeEventListener('click', swallow, true); }, 0);
      }
      track.addEventListener('pointerdown', onDown);
      track.addEventListener('pointermove', onMove);
      track.addEventListener('pointerup', onUp);
      track.addEventListener('pointercancel', onUp);
      track.addEventListener('pointerleave', function (e) { if (down) onUp(e); });
      track.addEventListener('dragstart', function (e) { e.preventDefault(); });
      sync();
    });
  }

  /* ---------------- T · Table peek: image follows the cursor over a hovered row ---------------- */
  function initTablePeek() {
    each(document.querySelectorAll('.bn-table--hover'), function (table) {
      if (bound(table)) return;
      if (!hoverable) return;
      var peek = document.createElement('div'); peek.className = 'bn-table__peek'; peek.setAttribute('aria-hidden', 'true');
      document.body.appendChild(peek);
      var imgs = {};
      var tx = 0, ty = 0, cx = 0, cy = 0, running = false, active = null;
      function frame() {
        cx += (tx - cx) * .16; cy += (ty - cy) * .16;
        peek.style.transform = 'translate3d(' + cx.toFixed(1) + 'px,' + cy.toFixed(1) + 'px,0) translate(-50%,-50%) scale(' + (active ? 1 : .9) + ')';
        if (Math.abs(tx - cx) > .3 || Math.abs(ty - cy) > .3 || active) requestAnimationFrame(frame); else running = false;
      }
      function kick() { if (!running) { running = true; requestAnimationFrame(frame); } }
      each(table.querySelectorAll('.bn-table__row'), function (row) {
        var src = row.getAttribute('data-peek'); if (!src) return;
        row.addEventListener('pointerenter', function (e) {
          active = row; row.classList.add('is-hot');
          var img = imgs[src];
          if (!img) { img = document.createElement('img'); img.alt = ''; img.src = src; imgs[src] = img; peek.appendChild(img); }
          each(peek.querySelectorAll('img'), function (i) { i.classList.toggle('is-on', i === img); });
          tx = e.clientX; ty = e.clientY; if (cx === 0 && cy === 0) { cx = tx; cy = ty; }
          peek.classList.add('is-on'); kick();
        });
        row.addEventListener('pointermove', function (e) { tx = e.clientX; ty = e.clientY; kick(); });
        row.addEventListener('pointerleave', function () { row.classList.remove('is-hot'); if (active === row) { active = null; peek.classList.remove('is-on'); } });
      });
    });
  }

  /* ---------------- A · FAQ height animation ---------------- */
  function initFaq() {
    each(document.querySelectorAll('.bn-faq__item'), function (d) {
      if (bound(d)) return;
      var body = d.querySelector('.bn-faq__body'); if (!body) return;
      var summary = d.querySelector('summary'); if (!summary) return;
      summary.addEventListener('click', function (e) {
        if (reduced) return; // native toggle
        e.preventDefault();
        if (d.open) {
          var h = body.offsetHeight; body.style.height = h + 'px'; body.style.overflow = 'hidden';
          void body.offsetHeight; // flush start values so height:h px is the before-change style
          requestAnimationFrame(function () { body.style.transition = 'height .4s cubic-bezier(.16,1,.3,1), opacity .3s'; body.style.height = '0px'; body.style.opacity = '0'; });
          setTimeout(function () { d.open = false; body.style.cssText = ''; }, 420);
        } else {
          d.open = true;
          var target = body.scrollHeight;
          body.style.height = '0px'; body.style.overflow = 'hidden'; body.style.opacity = '0';
          void body.offsetHeight; // flush start values so height:0 is the before-change style
          requestAnimationFrame(function () { body.style.transition = 'height .45s cubic-bezier(.16,1,.3,1), opacity .4s .1s'; body.style.height = target + 'px'; body.style.opacity = '1'; });
          setTimeout(function () { body.style.cssText = ''; }, 480);
        }
      });
    });
  }

  /* ---------------- W · Word-scroll: no gap at the loop point ----------------
     born.js clones the set once (2 copies). If the card is taller than one set, the
     window empties before the loop resets. Clone until the track is at least one card
     taller than a set — always an EVEN number of copies so translateY(-50%) equals a
     whole number of sets — and scale the duration so the speed stays constant. */
  function initWords3() {
    each(document.querySelectorAll('.bn-words__track'), function (track) {
      var orig = Array.prototype.filter.call(track.children, function (li) { return !li.hasAttribute('aria-hidden'); });
      if (!orig.length) return;
      // make sure at least one clone exists (born.js normally does this)
      if (!track.querySelector('[aria-hidden]')) orig.forEach(function (li) { var c = li.cloneNode(true); c.setAttribute('aria-hidden', 'true'); track.appendChild(c); });
      each(track.querySelectorAll('[aria-hidden] a'), function (a) { a.setAttribute('tabindex', '-1'); });
      var firstClone = track.querySelector('[aria-hidden]');
      var setH = firstClone.getBoundingClientRect().top - orig[0].getBoundingClientRect().top;
      var card = track.closest('.bn-card') || track.parentElement;
      var winH = card ? card.getBoundingClientRect().height : 0;
      if (setH <= 0 || winH <= 0) return;                       // not laid out yet (hidden tab) — try again later
      var have = Math.round(track.getBoundingClientRect().height / setH);
      var need = Math.ceil((winH + setH) / setH) + 1;
      if (need % 2) need++;                                       // even → -50% is a whole number of sets
      for (var k = have; k < need; k++) orig.forEach(function (li) { var c = li.cloneNode(true); c.setAttribute('aria-hidden', 'true'); each(c.querySelectorAll('a'), function (a) { a.setAttribute('tabindex', '-1'); }); track.appendChild(c); });
      var copies = Math.max(have, need);
      track.style.setProperty('--bn-words-dur', (11 * copies / 2) + 's');   // 11s per set travelled
      track.dataset.bnWords3 = String(copies);
    });
  }
  window.addEventListener('load', initWords3);
  window.addEventListener('resize', function () { clearTimeout(window.__bnW3); window.__bnW3 = setTimeout(initWords3, 200); });
  document.addEventListener('visibilitychange', function () { if (document.visibilityState === 'visible') initWords3(); });

  function boot() { initOrigin(); initRail3(); initTablePeek(); initFaq(); initWords3(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', boot);
})();